import React from 'react';
import classNames from 'classnames';
import { getContext, I18n } from '@fiverr-private/fiverr_context';
import { i18nPropType, translationButtonProps } from '../../../utils/props';
import withTranslationButtonWrapper from '../TranslationButtonWrapper';
import DisclaimerTooltip from '../DisclaimerTooltip';
import LeanTranslationIcon from './LeanTranslationIcon';

import './style.scss';

export const TranslateTo = ({ i18n }) => {
    const { locale } = getContext();
    const language = i18n.t(`languages.${locale}`);

    return (
        <I18n k="machine_translation.translate_to" params={{ language }}/>
    );
};

TranslateTo.propTypes = {
    i18n: i18nPropType
};

const LeanTranslationButton = ({
    loading = false,
    toggled = false,
    onClick = Function.prototype,
    i18n,
    disclaimerClassName
}) => {
    const className = classNames(
        'lean-translation-button',
        'text-body-3',
        { 'is-translating': loading },
        { 'is-translated': toggled }
    );

    const handleClick = () => {
        if (loading || toggled) {
            return;
        }

        onClick();
    };

    return (
        <span className={className}
            onClick={handleClick}>
            <LeanTranslationIcon isTranslating={loading}
                isTranslated={toggled}/>
            {
                toggled
                    ? (
                        <DisclaimerTooltip disclaimerClassName={disclaimerClassName}>
                            <I18n k="machine_translation.automatic_translation"/>
                        </DisclaimerTooltip>
                    )
                    : <TranslateTo i18n={i18n}/>
            }
        </span>
    );
};

LeanTranslationButton.propTypes = translationButtonProps;

export default withTranslationButtonWrapper(LeanTranslationButton);
